module.exports = __webpack_public_path__ + "static/man-40-47226b9a6501f3e18e932d4e411e113c.jpg";